import { render, staticRenderFns } from "./TableGudang.vue?vue&type=template&id=0cfb2c3a&"
import script from "./TableGudang.vue?vue&type=script&lang=js&"
export * from "./TableGudang.vue?vue&type=script&lang=js&"
import style0 from "./TableGudang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports